import { useState } from 'react';

export default function ShareActions({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(`${title} - ${url}`);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={handleCopy}
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
      >
        <i className={copied ? 'ri-check-line text-secondary-600' : 'ri-link'} aria-hidden="true" />
        {copied ? '链接已复制' : '复制链接'}
      </button>
      <a
        href="#comments"
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
      >
        <i className="ri-chat-3-line" aria-hidden="true" />
        看热评
      </a>
      <span
        aria-live="polite"
        className="text-xs text-secondary-700"
        role="status"
      >
        {copied ? '已复制到剪贴板，去分享给朋友吧' : ''}
      </span>
    </div>
  );
}